import $ from "jquery";

$.fn.forceNumeric = function () {
    return this.each(function () {
        $(this).on('keydown', function (e) {
            let key = e.which || e.keyCode;
            return (
                (!e.shiftKey &&
                    !e.altKey &&
                    !e.ctrlKey &&
                    // numbers
                    key >= 48 &&
                    key <= 57) ||
                // Numeric keypad
                (key >= 96 && key <= 105) ||
                // comma, period and minus, . on keypad
                key === 190 ||
                key === 188 ||
                key === 109 ||
                key === 110 ||
                // Backspace and Tab and Enter
                key === 8 ||
                key === 9 ||
                key === 13 ||
                // Home and End
                key === 35 ||
                key === 36 ||
                // left and right arrows
                key === 37 ||
                key === 39 ||
                // Del and Ins
                key === 46 ||
                key === 45
            );
        });
    });
};

$(document).ready(function () {
    $("[data-v-numeric]").forceNumeric();
    $("[data-us-phone]").mask('(000) 000-0000');
    $("[data-us-date]").mask('00/00/0000');
    // $("[data-zipcode-date]").mask('00000-ZZZZ');
});
